var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCandidateReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84396 5.78947C9.16653 5.78947 10.2387 4.71731 10.2387 3.39474C10.2387 2.07216 9.16653 1 7.84396 1C6.52138 1 5.44922 2.07216 5.44922 3.39474C5.44922 4.71731 6.52138 5.78947 7.84396 5.78947Z",
    stroke: "#848484",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.6612C1 10.638 3.75703 8.1875 7.1579 8.1875",
    stroke: "#848484",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11H9.5V14H8.5V11ZM10.5 8H11.5V14H10.5V8ZM12.5 9.5H13.5V14H12.5V9.5Z",
    fill: "#848484"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11H9.5V14H8.5V11ZM10.5 8H11.5V14H10.5V8ZM12.5 9.5H13.5V14H12.5V9.5Z",
    fill: "#848484"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateReport);
export default __webpack_public_path__ + "static/media/candidate-report.cceb4efdc3795b06e754a90df72bfa92.svg";
export { ForwardRef as ReactComponent };